import {
    Component,
    ElementRef,
    Inject,
    Input,
    OnInit,
    Optional,
    ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@cmps/ng-bootstrap';

import { CMPS_WIDGET_OPTIONS } from '../widget/widget.metadata';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { createTeamDashboardUrl } from '../widget/widget.util';

import {
    CaoOpportunityPopup,
    CaoOpportunityPopupMetric,
    CaoOpportunityPopupUser,
} from './cao-opportunity.widget.model';
import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';

@Component({
    selector: 'cmps-widget-cao-opportunity',
    templateUrl: './cao-opportunity.widget.component.html',
})
export class CaoOpportunityWidgetComponent implements OnInit {
    @ViewChild('popupEl')
    popupEl: ElementRef;

    @Input()
    options: any;

    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    data: CaoOpportunityPopup;
    table1RowIsCollapsed: any;
    table2RowIsCollapsed: any;
    currentDetail: CaoOpportunityPopupUser;
    currentMetricCyclePerformance: CaoOpportunityPopupMetric;

    constructor(
        private readonly _router: Router,
        public activeModal: NgbActiveModal,
        @Optional() @Inject(CMPS_WIDGET_OPTIONS) private readonly _options: any,
        private readonly _service: LegacyWidgetService,
    ) {
        this.options = _options || this.options || {};
    }

    ngOnInit(): void {
        this.hasPendingData = true;
        this._service.caoOpportunityPopup(this.options.userId).subscribe(
            (data) => {
                this.data = data;

                this.table1RowIsCollapsed = {};
                this.table2RowIsCollapsed = {};
                for (let i = 0; i < this.data.items.length; i++) {
                    this.table1RowIsCollapsed[i] = true;
                    this.table2RowIsCollapsed[i] = {};
                    for (
                        let j = 0;
                        j < this.data.items[i].metrics.length;
                        j++
                    ) {
                        this.table2RowIsCollapsed[i][j] = true;
                    }
                }
            },
            // eslint-disable-next-line n/handle-callback-err, no-return-assign
            (error) => (this.hasPendingData = false),
            // eslint-disable-next-line no-return-assign
            () => (this.hasPendingData = false),
        );
    }

    showDetails(item: CaoOpportunityPopupUser): void {
        this.currentDetail = item;
        this._scrollToCard();
    }

    showMetricCyclePerformance(item: CaoOpportunityPopupMetric): void {
        this.currentMetricCyclePerformance = item;
        this._scrollToCard();
    }

    private _scrollToCard(): void {
        // eslint-disable-next-line no-return-assign, @typescript-eslint/restrict-plus-operands
        setTimeout(
            () =>
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                (document.querySelector('ngb-modal-window').scrollTop +=
                    this.popupEl.nativeElement.getBoundingClientRect().top),
        );
    }

    goToJournal(url: string): void {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._router.navigate(['internal', 'webform'], {
            queryParams: { relativeUrl: url },
        });
        this.activeModal.close();
    }
}
